const PrivacyPolicyPage = () => {
  const BRAND = {
    navy: '#0A1A2F',
    white: '#FFFFFF',
    lightGray: '#E0E0E0',
    mutedGray: '#9CA3AF',
    red: '#E63946',
  };

  const Section = ({ number, title, children }) => (
    <div style={{ marginBottom: '28px' }}>
      <h2 style={{ color: BRAND.white, fontSize: '17px', fontWeight: 600, marginBottom: '8px' }}>
        {number}. {title}
      </h2>
      <div style={{ color: BRAND.lightGray, fontSize: '14px', lineHeight: '1.7' }}>
        {children}
      </div>
    </div>
  );

  return (
    <div
      style={{ backgroundColor: BRAND.navy, minHeight: '100vh', padding: '40px 20px' }}
      data-testid="privacy-policy-page"
    >
      <div style={{ maxWidth: '680px', margin: '0 auto' }}>
        <h1
          style={{ color: BRAND.red, fontSize: '26px', fontWeight: 700, marginBottom: '4px' }}
          data-testid="privacy-policy-title"
        >
          Privacy Policy
        </h1>
        <p style={{ color: BRAND.mutedGray, fontSize: '14px', marginBottom: '8px' }}>
          Dragonboat Pro Tracker (DBPRO)
        </p>
        <p style={{ color: BRAND.mutedGray, fontSize: '13px', marginBottom: '36px' }}>
          Last updated: May 1, 2026
        </p>

        <Section number={1} title="Introduction">
          Dragonboat Pro Tracker ("DBPRO") is a GPS-based training tracking application designed for
          dragon boat coaches, drummers, steersmen, and team captains. This Privacy Policy explains
          how we collect, use, and protect your personal information when you use our app at
          dragonboatprotracker.com.
        </Section>

        <Section number={2} title="Information We Collect">
          <p>We collect:</p>
          <ul style={{ paddingLeft: '20px', marginTop: '6px' }}>
            <li>Your name and email address when you register</li>
            <li>GPS location data during training sessions</li>
            <li>Training session data including distance, speed, time, and splits</li>
            <li>Device information for app performance</li>
          </ul>
        </Section>

        <Section number={3} title="How We Use Your Information">
          <p>We use your information to:</p>
          <ul style={{ paddingLeft: '20px', marginTop: '6px' }}>
            <li>Provide GPS tracking and session recording features</li>
            <li>Display your training history and performance data</li>
            <li>Improve the app experience</li>
            <li>Contact you about your account or app updates</li>
          </ul>
        </Section>

        <Section number={4} title="Data Storage">
          Your data is stored securely on our servers. We do not sell your personal data to third parties.
        </Section>

        <Section number={5} title="Google Login">
          If you sign in using Google, we receive your name and email address from Google. We do not
          receive your Google password.
        </Section>

        <Section number={6} title="Location Data">
          GPS location data is only collected during active training sessions when you start a session
          in the app. Location data is used solely to calculate distance, speed, and route for your
          training records.
        </Section>

        <Section number={7} title="Your Rights">
          <p>You have the right to:</p>
          <ul style={{ paddingLeft: '20px', marginTop: '6px' }}>
            <li>Access your personal data</li>
            <li>Request deletion of your account and data</li>
            <li>Opt out of communications</li>
          </ul>
          <p style={{ marginTop: '8px' }}>
            To exercise these rights, contact us at{' '}
            <a href="mailto:raffy3740@gmail.com" style={{ color: BRAND.red }}>raffy3740@gmail.com</a>.
          </p>
        </Section>

        <Section number={8} title="Children's Privacy">
          DBPRO is not intended for users under the age of 13. We do not knowingly collect data from children.
        </Section>

        <Section number={9} title="Changes to This Policy">
          We may update this Privacy Policy from time to time and will notify users of significant
          changes via email or in-app notification.
        </Section>

        <Section number={10} title="Contact Us">
          <p>
            Email:{' '}
            <a href="mailto:raffy3740@gmail.com" style={{ color: BRAND.red }}>raffy3740@gmail.com</a>
          </p>
          <p>
            Website:{' '}
            <a href="https://www.dragonboatprotracker.com" style={{ color: BRAND.red }} target="_blank" rel="noopener noreferrer">
              https://www.dragonboatprotracker.com
            </a>
          </p>
        </Section>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
